import { render, staticRenderFns } from "./PageTemplateItem.vue?vue&type=template&id=232adaf1&scoped=true&"
import script from "./PageTemplateItem.vue?vue&type=script&lang=js&"
export * from "./PageTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplateItem.vue?vue&type=style&index=0&id=232adaf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232adaf1",
  null
  
)

export default component.exports